<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="经纬度">
            <el-select v-model="form.longitudeAndLatitude" clearable filterable>
              <el-option v-for="(item, index) in tableData" :label="item.longitudeAndLatitude" :value="item.longitudeAndLatitude" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网点编号">
            <el-input v-model="form.outletNo"></el-input>
          </el-form-item>
          <el-form-item label="选择地区">
            <el-cascader :options="options" v-model="form.region" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="您确定要删除多条数据吗？" @confirm="deleteMapData">
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBorderColor" @click="exportData">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')">新增地址</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="table" v-loading="loading" :data="tableData" border tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="handleSelectionChange" max-height="550">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="longitudeAndLatitude" label="经纬度" min-width="140" align="center"> </el-table-column>
          <el-table-column prop="outletNo" label="网点编号" min-width="80" align="center" />
          <el-table-column prop="storeName" label="店面名称" min-width="180" align="center" show-overflow-tooltip />
          <el-table-column prop="province" label="省份" min-width="120" align="center" />
          <el-table-column prop="city" label="城市" min-width="120" align="center" />
          <el-table-column prop="prefecture" label="县区" min-width="120" align="center" />
          <el-table-column prop="address" label="详细地址" show-overflow-tooltip min-width="160" align="center" />
          <el-table-column label="操作" min-width="100" align="center">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm title="您确认要删除该条数据吗？" @confirm="deleteOnly(scope.row)">
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page" :page-sizes="[20, 40, 60, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes" :total="total"> </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog :title="`${title}地址`" :visible.sync="dialogVisible" width="750px" @close="cancelBtn('dialogForm')">
      <div class="forms">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="160px" class="demo-dialogForm" label-position="left">
          <el-form-item label="经纬度" prop="longitudeAndLatitude">
            <el-input v-model="dialogForm.longitudeAndLatitude"></el-input>
          </el-form-item>
          <el-form-item label="网点编号" prop="outletNo">
            <el-input v-model="dialogForm.outletNo"></el-input>
          </el-form-item>
          <el-form-item label="店面名称" prop="storeName">
            <el-input v-model="dialogForm.storeName"></el-input>
          </el-form-item>
          <el-form-item label="选择地区" prop="region">
            <el-cascader :options="options" v-model="dialogForm.region" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="dialogForm.address"></el-input>
          </el-form-item>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')">取 消</el-button>
            <el-button class="dialogBtnBackgory" @click="submitForm('dialogForm')">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <Export ref="exportDialog" :type="type" :downloadTitle="downloadTitle" :getSearchList="getSearchList"></Export>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
import Export from "../exportFile/export.vue";
export default {
  name: "mapManage",
  components: {
    Export
  },
  data() {
    return {
      form: {
        longitudeAndLatitude: "",
        longitude: "", //经度
        latitude: "", //纬度
        outletNo: "",
        region: "",
        province: "", //省
        city: "", //市
        prefecture: "" //区
      },
      options: regionData,
      ids: [],
      title: "新增",
      selectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },

      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        longitudeAndLatitude: "",
        outletNo: "",
        storeName: "",
        region: [],
        address: "",
        province: "", //省
        city: "", //市
        prefecture: "" //区
      },
      dialogRules: {
        longitudeAndLatitude: [{ required: true, message: "请输入经纬度", trigger: "blur" }],
        outletNo: [{ required: true, message: "请输入网点编号", trigger: "change" }],
        storeName: [{ required: true, message: "请输入店面名称", trigger: "change" }],
        region: [{ required: true, message: "请选择省市区", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "change" }]
      },
      type: "gzh_map",
      downloadTitle: "线下网点导入模板"
    };
  },
  mounted() {
    this.getSeleteDataList();

    this.getSearchList({ ...this.pageData });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {},
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    exportData() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.$refs[formName]?.resetFields();
    },

    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.mapDataList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        longitude: this.form.longitudeAndLatitude?.split(",")[0], //经度
        latitude: this.form.longitudeAndLatitude?.split(",")[1], //纬度
        outletNo: this.form.outletNo,
        province: CodeToText[this.form.region[0]], //省
        city: CodeToText[this.form.region[1]], //市
        prefecture: CodeToText[this.form.region[2]] //区
      };
      this.getSearchList(json);
    },
    // 批量 删除
    deleteMapData() {
      if (this.ids.length) {
        apis.mapDeleteMap(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const json = {
            outletNo: this.dialogForm.outletNo,
            storeName: this.dialogForm.storeName,
            province: CodeToText[this.dialogForm.region[0]], //省
            city: CodeToText[this.dialogForm.region[1]], //市
            prefecture: CodeToText[this.dialogForm.region[2]], //区
            address: this.dialogForm.address
          };
          if (this.dialogForm.longitudeAndLatitude.indexOf(",") !== -1) {
            (json.longitude = this.dialogForm.longitudeAndLatitude?.split(",")[0]), //经度
              (json.latitude = this.dialogForm.longitudeAndLatitude?.split(",")[1]); //纬度
          } else if (this.dialogForm.longitudeAndLatitude.indexOf("，") !== -1) {
            (json.longitude = this.dialogForm.longitudeAndLatitude?.split("，")[0]), //经度
              (json.latitude = this.dialogForm.longitudeAndLatitude?.split("，")[1]); //纬度
          }
          if (this.dialogForm.id) {
            json.id = this.dialogForm.id;
          }
          apis.mapAddAndEdit(json).then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              this.dialogVisible = false;
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.rowId = row.id;
      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          longitudeAndLatitude: row.longitudeAndLatitude,
          outletNo: row.outletNo,
          storeName: row.storeName,
          region: [TextToCode[row.province]?.code, TextToCode[row.province][row.city]?.code, TextToCode[row.province][row.city][row.prefecture]?.code],
          address: row.address
        })
      );
      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 删除一条
    deleteOnly(row) {
      apis.mapDeleteMap([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
// 1 解决 table 表头和内容错误
// ::v-deep .el-table {
//   th.gutter,
//   colgroup.gutter {
//     width: 17px !important;
//   }
// }
// ::v-deep .el-table__header colgroup col[name="gutter"] {
//   display: table-cell !important;
// }
// ::v-deep .el-table {
//   &::-webkit-scrollbar {
//     display: none;
//   }
// }

::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
</style>
